import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-townplanner-info-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-townplanner-info-tpams.component.scss?ngResource";
import { Component } from "@angular/core";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
import { AlertType } from "../../../../../../shared/models/alert";
import { AutoUnsub } from "../../../../../../shared/decorators/autounsub.decorator";
let SearchTownplannerInfoTpamsComponent = class SearchTownplannerInfoTpamsComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    townplannerLabel = ApplicationSearchConstants.FORM_CONTROLS.townplannerLabel;
    townPlannerFormControl = ApplicationSearchConstants.FORM_CONTROLS.townPlannerFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    townPlannerForm;
    townplanners;
    applicationSearchCallback;
    getTownplannersSubscription;
    constructor(applicationSearchService, aflaModuleStrategyService, appController) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
    }
    ngOnInit() {
        this.setUpForm();
        this.getTownplannersSubscription = this.applicationSearchService.getTownplanners(Number(this.appController.selectedModuleID))
            .subscribe((recipients) => {
            this.townplanners = recipients.value;
        });
    }
    searchApplication($event) {
        const townplannerId = this.townPlannerForm.get(this.townPlannerFormControl).value;
        if (townplannerId !== "") {
            this.applicationSearchCallback(this.applicationSearchService.searchByTownplanner(Number(townplannerId), Number(this.appController.selectedModuleID), this.aflaModuleStrategyService));
        }
        else {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
        }
    }
    setUpForm() {
        this.townPlannerForm = new FormGroup({
            townPlannerFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService }
    ];
};
SearchTownplannerInfoTpamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-townplanner-info-tpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchTownplannerInfoTpamsComponent);
export { SearchTownplannerInfoTpamsComponent };
